import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { postRSSLink } from '../../../api/channels';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';

import { REQUEST } from '../../../constants/request';

export const createRssLink = createAsyncThunk(
  'channels/createRssLink',
  async (rssData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await postRSSLink(rssData, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const channelCIDKey = generateChannelCIDKey(path);
      const state = getState();

      return !(
        state.items.rssLinks.actions.create.request[channelCIDKey]?.loading ===
        REQUEST.pending
      );
    },
  },
);

export const createRssLinkExtraReducers = {
  [createRssLink.pending]: (state, action) => {
    checkAndSetLoadingWithId(
      state.rssLinks.actions.create.request,
      action,
      generateChannelCIDKey(action.meta.arg.path),
    );
  },
  [createRssLink.fulfilled]: (state, action) => {
    onMatchedRequest(
      state.rssLinks.actions.create.request[
        generateChannelCIDKey(action.meta.arg.path)
      ],
      action,
      () => {
        const channelCIDKey = generateChannelCIDKey(action.payload);

        state.rssLinks.byId[channelCIDKey] = action.payload;
        state.rssLinks.allIds.push(channelCIDKey);
      },
    );
  },
  [createRssLink.rejected]: (state, action) => {
    handleRequestRejection(
      state.rssLinks.actions.create.request[
        generateChannelCIDKey(action.meta.arg.path)
      ],
      action,
    );
  },
};
